/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	jQuery(document).ready(function ($) {
	  var timelineBlocks = $('.cd-timeline-block'),
	      offset = 0.9;
	
	  //hide timeline blocks which are outside the viewport
	  hideBlocks(timelineBlocks, offset);
	
	  //on scolling, show/animate timeline blocks when enter the viewport
	  $(window).on('scroll', function () {
	    !window.requestAnimationFrame ? setTimeout(function () {
	      showBlocks(timelineBlocks, offset);
	    }, 100) : window.requestAnimationFrame(function () {
	      showBlocks(timelineBlocks, offset);
	    });
	  });
	
	  function hideBlocks(blocks, offset) {
	    blocks.each(function () {
	      $(this).offset().top > $(window).scrollTop() + $(window).height() * offset && $(this).find('.cd-timeline-img, .cd-timeline-content').addClass('is-hidden');
	    });
	  }
	
	  function showBlocks(blocks, offset) {
	    blocks.each(function () {
	      $(this).offset().top <= $(window).scrollTop() + $(window).height() * offset && $(this).find('.cd-timeline-img').hasClass('is-hidden') && $(this).find('.cd-timeline-img, .cd-timeline-content').removeClass('is-hidden').addClass('bounce-in');
	    });
	  }
	});

/***/ }
/******/ ]);


/** WEBPACK FOOTER **
 ** timeline.js
 **/